export default __webpack_public_path__ + "static/media/artic.4be6b947.jpg";